import { gtmAddEvents, globalSiteTag } from '../../common/utils/googleAdUtils';

const PAGE_NAME = 'holidaylisting';

export const gtmClick = eventName => {
  gtmAddEvents({ eventName, pageName: PAGE_NAME });
};

export const gtmLoad = ({ destination, paxStr, travelDate, departureCity, flights }) => {
  globalSiteTag(PAGE_NAME, { destination, paxStr, travelDate, departureCity, flights });
};
